__webpack_require__.p = "https://cdn.jewlr.com/packs/";